import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import {ImportTemplateComponent} from './import-template.component';

const routes: Routes = [
  {
    path: 'import-template',
    component: ImportTemplateComponent,
    data: {
      title: 'Import Template'
    }
  }
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule],
  providers: []
})
export class ImportTemplateRoutingModule { }



// WEBPACK FOOTER //
// ./src/app/pages/import-template/import-template-routing.module.ts